import { FilterType } from '@/components/_common/Filters/FilterDictionary';

/**
 * Convert a filter array to a map keyed by filter ID.
 */
export const mapFiltersById = (filters: FilterType[]): Record<string, FilterType> => {
  return filters.reduce<Record<string, FilterType>>((acc, filter) => {
    acc[filter.id] = filter;
    return acc;
  }, {});
};
